// @flow
import EmployeesOffice from './EmployeesOffice';

export default EmployeesOffice;
